/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_Book_TitleInputs */

const en_portal_rail_book_title = /** @type {(inputs: Portal_Rail_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions with a coach`)
};

const pl_portal_rail_book_title = /** @type {(inputs: Portal_Rail_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningi z trenerem`)
};

/**
* | output |
* | --- |
* | "Sessions with a coach" |
*
* @param {Portal_Rail_Book_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_book_title = /** @type {((inputs?: Portal_Rail_Book_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_Book_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_book_title(inputs)
	return en_portal_rail_book_title(inputs)
});